// Key under which the menu stores the unread posts of a type (useUnread). The
// menu item is built from `notifUrl` ("not-viewed-posts"), so every reader of
// the posts must use this same key.
export const postUnreadKey = (typeId: number | string) =>
	"not-viewed-posts_" + typeId;
